/* mobile sandwich behavior on 320-640 */
function catalogMobileSandwichPositionDefine(){
    var wS = $(window).scrollTop(),
        res = resolutionCheck(),
        pageHeadHeight = $('.page-title').outerHeight(),
        headerHeight = $('header').height();
/*     console.log(pageHeadHeight + headerHeight); */
    if (res == 32) {
        if (wS > pageHeadHeight + headerHeight - 20) {
            $('.btn--cat-320-sandwich').addClass('fixed');
        }
        else {
            $('.btn--cat-320-sandwich').removeClass('fixed');
        }
    }
}
$(window).on('load scroll resize orientationchange',function(){
    if ($('.btn--cat-320-sandwich').length){
        catalogMobileSandwichPositionDefine();
    }
});

$(document).on('click',  '#mobile-sandwich', function(){
    $('.cat-menu').css('display', 'block');
    $('.cat-menu-col__btn-mobile').css('display', 'none');
    overlayStart();
});
$(document).on('click', '.cat-menu__head-cross', function(){
    var res = resolutionCheck();
    if(res == 32){
        $('.cat-menu-col__btn-mobile').css('display', 'block');
        overlayEnd();
    }
});
